module.exports = __webpack_public_path__ + "img/XX.99c71919.png";